import {withAuthenticationRequired} from "@auth0/auth0-react";
import PageLoader from "../PageLoader";
import {useMemo} from "react";

const AuthGuard = ({ component, ...props }) => {
    const Component = useMemo(
        () =>
            withAuthenticationRequired(component, {
                onRedirecting: () => <PageLoader text="Loading" />,
            }),
        [component]
    );

    return <Component {...props} />;
};

export default AuthGuard;